// HISTÓRICO CONGELADO F3c (proyeccionModal): copia literal del cálculo anterior del modal de detalle de la
// Proyección de ventas (hardware + cartelería). Producción lo usa para los meses < CORTE_HISTORICO (2026-10).
import { convertirAMonedaLocal } from "../../exchangeRateService";

export const detalleModalCarteleriaHistorico = ({
  negocios,
  vertical,
  isCierres,
  ano,
  start,
  end,
  pais,
  edificios,
  clientes,
}) => {
  let todas = [];

  // HARDWARE
  if (vertical === "hardware" || vertical === null) {
    const hardwareItems = negocios
      .filter((n) => {
        if (!n.incluye_hardware || n.eliminada) return false;
        if (!["100%", "Activo"].includes(n.estado)) return false;
        return true;
      })
      .map((n) => {
        // Cascada: edificios → clientes → fallback (igual que CarteleriaList)
        let nombreReferencia = `ID ${n.referencia_id || n.id}`;
        if (n.referencia_id && edificios[n.referencia_id]) {
          nombreReferencia = edificios[n.referencia_id]?.edificio;
        } else if (n.referencia_id && clientes[n.referencia_id]) {
          nombreReferencia = clientes[n.referencia_id]?.empresa || clientes[n.referencia_id]?.nombre;
        }

        const monedaHW = (n.moneda_hardware || "UF").toUpperCase();
        const esUF = monedaHW.includes("UF");

        let importeMesOriginal = 0;
        let importeMesConvertido = 0;
        let incluyeEnMes = false;
        const ultimoDiaMes = new Date(ano, end, 0);
        const fechaConversion = ultimoDiaMes.toISOString().split("T")[0];

        if (isCierres) {
          const fecha = new Date(n.fecha_cierre);
          if (!isNaN(fecha)) {
            const mesNegocio = fecha.getMonth() + 1;
            const anoNegocio = fecha.getFullYear();
            if (anoNegocio === ano && mesNegocio >= start && mesNegocio <= end) {
              incluyeEnMes = true;
              importeMesOriginal = Number(n.monto_hardware) || 0;
              importeMesConvertido = convertirAMonedaLocal(importeMesOriginal, monedaHW, pais, fechaConversion);
            }
          }
        } else {
          // Detalle del modal Hardware: MISMO criterio que el agregado (calcularHardwareMensual).
          // Mes de FACTURACIÓN del tramo (devengo, 10.143), cascada: fecha real (`facturafecha` ||
          // `fecha_factura`) → `fecha_factura_estimada` del tramo pendiente → `fecha_cierre` (fallback
          // tramos viejos). `fecha_cobro_estimada` NO participa (es dato de cobro/Caja).
          const tieneDesglose =
            n.modalidad === "CAPEX" && Array.isArray(n.detalle_pagos_hardware) && n.detalle_pagos_hardware.length > 0;

          if (tieneDesglose) {
            const pagosMes = n.detalle_pagos_hardware.filter((pago) => {
              const fechaTramo =
                pago.facturafecha || pago.fecha_factura || pago.fecha_factura_estimada || n.fecha_cierre;
              if (!fechaTramo || pago.monto == null) return false;
              const fecha = new Date(fechaTramo);
              const mes = fecha.getMonth() + 1;
              const añoPago = fecha.getFullYear();
              return añoPago === ano && mes >= start && mes <= end;
            });
            if (pagosMes.length > 0) {
              incluyeEnMes = true;
              importeMesOriginal = pagosMes.reduce((sum, pago) => sum + (Number(pago.monto) || 0), 0);
              importeMesConvertido = pagosMes.reduce((sum, pago) => {
                const fechaPago = (pago.facturafecha || pago.fecha_factura)?.split("T")[0] || fechaConversion;
                return sum + convertirAMonedaLocal(Number(pago.monto) || 0, monedaHW, pais, fechaPago);
              }, 0);
            }
          } else if (n.modalidad === "CAPEX" && n.fecha_cierre) {
            const fecha = new Date(n.fecha_cierre);
            const mes = fecha.getMonth() + 1;
            const añoFecha = fecha.getFullYear();
            if (añoFecha === ano && mes >= start && mes <= end) {
              incluyeEnMes = true;
              importeMesOriginal = Number(n.monto_hardware) || 0;
              importeMesConvertido = convertirAMonedaLocal(importeMesOriginal, monedaHW, pais, fechaConversion);
            }
          } else if (n.modalidad === "OPEX" && n.cuota_hardware_opex && n.fecha_cierre) {
            const fechaCierre = new Date(n.fecha_cierre);
            const mesCierre = fechaCierre.getMonth();
            const añoCierre = fechaCierre.getFullYear();
            const totalCuotas = Number(n.num_cuotas) || Number(n.plazo_contrato_meses) || 36;

            for (let i = 0; i < totalCuotas; i++) {
              const mesTotal = mesCierre + i;
              const añoActual = añoCierre + Math.floor(mesTotal / 12);
              const mesActual = mesTotal % 12;
              if (añoActual === ano && mesActual + 1 >= start && mesActual + 1 <= end) {
                incluyeEnMes = true;
                const pantallas = Number(n.cantidad_pantallas) || 1;
                importeMesOriginal = Number(n.cuota_hardware_opex) * pantallas;
                importeMesConvertido = convertirAMonedaLocal(importeMesOriginal, monedaHW, pais, fechaConversion);
                break;
              }
            }
          }
        }

        return {
          ...n,
          esBTL: false,
          esCarteleria: false,
          esHardware: true,
          cliente: nombreReferencia,
          importe: importeMesConvertido,
          importeOriginal: importeMesOriginal,
          monedaOriginal: monedaHW,
          esMonedaUF: esUF,
          incluyeEnMes,
        };
      })
      .filter((item) => item.incluyeEnMes);

    todas = [...todas, ...hardwareItems];
  }

  // CARTELERÍA
  if (vertical === "carteleria" || vertical === null) {
    const resolverNombreReferencia = (n) => {
      if (n.referencia_id && edificios[n.referencia_id]) {
        return edificios[n.referencia_id]?.edificio;
      }
      if (n.referencia_id && clientes[n.referencia_id]) {
        return clientes[n.referencia_id]?.empresa || clientes[n.referencia_id]?.nombre;
      }
      return `ID ${n.referencia_id || n.id}`;
    };

    if (isCierres) {
      const ultimoDiaMes = new Date(ano, end, 0);
      const fechaConversion = ultimoDiaMes.toISOString().split("T")[0];

      negocios.forEach((n) => {
        if (n.eliminada) return;
        if (!["100%", "Activo"].includes(n.estado)) return;

        const pantallas = parseInt(n.cantidad_pantallas) || 1;
        const plazo = parseInt(n.plazo_contrato_meses) || 0;
        const gestion = parseFloat(n.fee_gestion_unitario) || 0;
        const contenidosUnit = parseFloat(n.fee_contenidos_unitario) || 0;
        const tieneContenidosRangoPropio = Boolean(n.incluye_contenidos && n.contenidos_fecha_inicio);
        const contenidosEnBase = n.incluye_contenidos && !tieneContenidosRangoPropio ? contenidosUnit : 0;

        const monedaGestion = (n.moneda_gestion || "UF").toUpperCase();
        const monedaContenidos = (n.moneda_contenidos || "UF").toUpperCase();
        const esUF = monedaGestion.includes("UF") || monedaContenidos.includes("UF");
        const nombreReferencia = resolverNombreReferencia(n);

        // Cierre base (gestión + contenidos si no hay rango propio)
        if (n.fecha_cierre) {
          const fecha = new Date(n.fecha_cierre + "T00:00:00");
          if (!isNaN(fecha)) {
            const mesNegocio = fecha.getMonth() + 1;
            if (fecha.getFullYear() === ano && mesNegocio >= start && mesNegocio <= end) {
              const gestionLocal = convertirAMonedaLocal(gestion * pantallas, monedaGestion, pais, fechaConversion);
              const contenidosLocal = convertirAMonedaLocal(
                contenidosEnBase * pantallas,
                monedaContenidos,
                pais,
                fechaConversion
              );
              const montoMensualOriginal = (gestion + contenidosEnBase) * pantallas;
              const montoTotalOriginal = montoMensualOriginal * plazo;
              const montoTotalCLP = (gestionLocal + contenidosLocal) * plazo;

              todas.push({
                ...n,
                esBTL: false,
                esCarteleria: true,
                esHardware: false,
                cliente: nombreReferencia,
                importe: montoTotalCLP,
                importeOriginal: montoTotalOriginal,
                monedaOriginal: monedaGestion,
                esMonedaUF: esUF,
                pantallas,
                plazo,
                feeGestion: gestion,
                feeContenidos: contenidosEnBase,
              });
            }
          }
        }

        // Cierre adicional de contenidos con rango propio
        if (tieneContenidosRangoPropio) {
          const fechaCont = new Date(n.contenidos_fecha_inicio + "T00:00:00");
          if (!isNaN(fechaCont)) {
            const mesCont = fechaCont.getMonth() + 1;
            if (fechaCont.getFullYear() === ano && mesCont >= start && mesCont <= end) {
              const fechaFinCont = n.contenidos_fecha_fin ? new Date(n.contenidos_fecha_fin + "T00:00:00") : null;
              const plazoCont = fechaFinCont
                ? (fechaFinCont.getFullYear() - fechaCont.getFullYear()) * 12 +
                  (fechaFinCont.getMonth() - fechaCont.getMonth()) +
                  1
                : parseInt(n.plazo_contrato_meses) || 0;

              const contenidosLocal = convertirAMonedaLocal(
                contenidosUnit * pantallas,
                monedaContenidos,
                pais,
                fechaConversion
              );
              const montoMensualOriginal = contenidosUnit * pantallas;
              const montoTotalOriginal = montoMensualOriginal * plazoCont;
              const montoTotalCLP = contenidosLocal * plazoCont;

              todas.push({
                ...n,
                id: `${n.id}-contenidos`,
                esBTL: false,
                esCarteleria: true,
                esHardware: false,
                cliente: `${nombreReferencia} (contenidos)`,
                importe: montoTotalCLP,
                importeOriginal: montoTotalOriginal,
                monedaOriginal: monedaContenidos,
                esMonedaUF: monedaContenidos.includes("UF"),
                pantallas,
                plazo: plazoCont,
                feeGestion: 0,
                feeContenidos: contenidosUnit,
              });
            }
          }
        }
      });
    } else {
      todas = [
        ...todas,
        ...negocios
          .filter((n) => {
            if (n.eliminada) return false;
            if (!["100%", "Activo"].includes(n.estado) || !n.fecha_inicio) return false;
            const fechaInicio = new Date(n.fecha_inicio);
            const plazoMeses = parseInt(n.plazo_contrato_meses) || 0;
            if (plazoMeses === 0) return false;
            const fechaFin = new Date(fechaInicio);
            fechaFin.setMonth(fechaFin.getMonth() + plazoMeses);
            const ultimoDiaPeriodo = new Date(ano, end, 0);
            const primerDiaPeriodo = new Date(ano, start - 1, 1);
            return fechaInicio <= ultimoDiaPeriodo && primerDiaPeriodo < fechaFin;
          })
          .map((n) => {
            const pantallas = parseInt(n.cantidad_pantallas) || 1;
            const plazo = parseInt(n.plazo_contrato_meses) || 0;
            const gestion = parseFloat(n.fee_gestion_unitario) || 0;
            const contenidos = n.incluye_contenidos ? parseFloat(n.fee_contenidos_unitario) || 0 : 0;

            const monedaGestion = (n.moneda_gestion || "UF").toUpperCase();
            const monedaContenidos = (n.moneda_contenidos || "UF").toUpperCase();
            const esUF = monedaGestion.includes("UF") || monedaContenidos.includes("UF");

            const montoMensualOriginal = (gestion + contenidos) * pantallas;

            const ultimoDiaMes = new Date(ano, end, 0);
            const fechaConversion = ultimoDiaMes.toISOString().split("T")[0];

            const gestionCLP = convertirAMonedaLocal(gestion * pantallas, monedaGestion, pais, fechaConversion);
            const contenidosCLP = convertirAMonedaLocal(
              contenidos * pantallas,
              monedaContenidos,
              pais,
              fechaConversion
            );
            const montoMensualCLP = gestionCLP + contenidosCLP;

            return {
              ...n,
              esBTL: false,
              esCarteleria: true,
              esHardware: false,
              cliente: resolverNombreReferencia(n),
              importe: montoMensualCLP,
              importeOriginal: montoMensualOriginal,
              monedaOriginal: monedaGestion,
              esMonedaUF: esUF,
              pantallas,
              plazo,
              feeGestion: gestion,
              feeContenidos: contenidos,
            };
          }),
      ];
    }
  }
  return todas;
};
